<template>
		<div v-bind:class="{active: active}" tabindex="0" @focusout="onFocusOut" >
			<div @click="onButtonClick" class="icon-menu" v-bind:class="{active: active}">
				<div class="icon-menu-line"></div>
			</div>
			<div class="dropdown-list">
				<slot name="dropdown"></slot>
			</div>
		</div>
</template>

<script>
	export default {
		data() {
			return {
				active: false
			}
		},
		mounted() {

		},
		methods: {
			onButtonClick() {
				if (!this.active) {
					this.active = true;
				} 
				else {
					setTimeout(() => {
						this.active = false;
					}, 300);
				}
			},
			onFocusOut() {
				if (this.active) {
					setTimeout(() => {
						this.active = false;
					}, 500);
				}
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DropdownMain.vue